<script>
import FeatureBlock from '@/components/FeatureBlock.vue'
import { gsap } from 'gsap'
import { CustomEase } from 'gsap/CustomEase'
import { CSSPlugin } from 'gsap/CSSPlugin'
gsap.registerPlugin(CSSPlugin)
export default {
  name: 'SupportBlocks',
  components: {
    FeatureBlock
  },
  data () {
    return {
      isVisible: false,
    }
  },
  methods: {
    visibilityChanged (isVisible) {
      this.isVisible = isVisible;
      // if (isVisible) {
        // gsap.from(".support-blocks-grid-item", { opacity: 1, y: 20, duration: 2.15, stagger: 0.25, ease: CustomEase.create("custom", "M0,0 C0,0 0.015,0.156 0.021,0.226 0.033,0.373 0.054,0.719 0.065,0.867 0.07,0.941 0.079,1.055 0.085,1.115 0.089,1.162 0.1,1.254 0.106,1.293 0.109,1.31 0.113,1.33 0.116,1.341 0.119,1.349 0.124,1.365 0.128,1.369 0.131,1.372 0.137,1.372 0.14,1.369 0.145,1.365 0.153,1.344 0.156,1.334 0.161,1.319 0.251,1.012 0.383,1.012 0.668,1.012 1,1 1,1 ") });
      // }
    }
  }
}
</script>

<template>
  <article class="support-blocks">
    <div class="support-blocks-grid"
         v-observe-visibility="{
      callback: visibilityChanged,
      throttle: 300
    }"
         :class="{'is-visible': isVisible}"
    >
      <feature-block
          id="block0"
          class="support-blocks-grid-item"
          style="--animation-order: 1;"
          :has-image="true"
          image-area-background="background-color: #40a6dc"
      >
        <template #image>
          <div class="image-container">
            <svg style="display: block;" xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 256 256">
              <path fill="currentColor" d="M193.69,164.58c-12.32,0-24.12,4.98-32.7,13.81l-52.68-33.86c4.14-10.63,4.14-22.42,0-33.05l52.68-33.86c17.63,18.06,46.57,18.41,64.63.78,18.06-17.63,18.41-46.57.78-64.63-17.63-18.06-46.57-18.41-64.63-.78-13.11,12.8-17.31,32.19-10.67,49.26l-52.68,33.86c-17.61-18.08-46.55-18.46-64.63-.85-18.08,17.61-18.46,46.55-.85,64.63,17.61,18.08,46.55,18.46,64.63.85.29-.28.57-.56.85-.85l52.68,33.86c-9.13,23.54,2.56,50.01,26.09,59.14,23.54,9.13,50.01-2.56,59.14-26.09,9.13-23.54-2.56-50.01-26.09-59.14-5.27-2.04-10.88-3.09-16.54-3.09M193.69,18.32c15.15,0,27.42,12.28,27.42,27.42s-12.28,27.42-27.42,27.42-27.42-12.28-27.42-27.42,12.28-27.42,27.42-27.42M65.71,155.44c-15.15,0-27.42-12.28-27.42-27.42s12.28-27.42,27.42-27.42,27.42,12.28,27.42,27.42-12.28,27.42-27.42,27.42M193.69,237.71c-15.15,0-27.42-12.28-27.42-27.42s12.28-27.42,27.42-27.42,27.42,12.28,27.42,27.42-12.28,27.42-27.42,27.42"/>
            </svg>
          </div>
        </template>
        <template #title>
          <div style="text-align: center;">
            Integrated Therapy Resources
          </div>
        </template>
        <template #content>
          <div style="text-align: center;">
            Videos, worksheets, and protocols in one place
          </div>
        </template>
      </feature-block>
      <feature-block
          id="block1"
          class="support-blocks-grid-item"
          style="--animation-order: 2;"
          :has-image="true"
          image-area-background="background-color: #40a6dc"
      >
        <template #image>
          <div class="image-container">
            <svg style="display: block;" xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 80 80">
              <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1">
                <rect fill="currentColor" x="1.05" y="1.05" width="32.53" height="32.53" rx="4" ry="4"/>
                <rect fill="currentColor" x="44.42" y="1.05" width="32.53" height="32.53" rx="4" ry="4"/>
                <rect fill="currentColor" x="1.05" y="44.42" width="32.53" height="32.53" rx="4" ry="4"/>
                <path stroke-linejoin="round" stroke-width="6" d="M44.25,60.69h32.53M60.51,44.42v32.53"/>
              </g>
            </svg>
          </div>
        </template>
        <template #title>
          <div style="text-align: center;">
            Expanding Activity Library
          </div>
        </template>
        <template #content>
          <div style="text-align: center;">
            New activities added regularly across age groups and skill levels
          </div>
        </template>
      </feature-block>
      <feature-block
          id="block2"
          class="support-blocks-grid-item"
          style="--animation-order: 3;"
          :has-image="true"
          image-area-background="background-color: #40a6dc"
      >
        <template #image>
          <div class="image-container">
            <svg style="display: block;" width="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path fill="currentColor" d="M12.88,7.93c0-.48-.4-.88-.88-.88s-.88.4-.88.88v5.83c0,.32.16.61.44.76l4.6,2.66c.42.25.96.09,1.19-.32.25-.42.09-.96-.32-1.21h0l-4.16-2.4v-5.33h-.01Z"/>
              <path fill="currentColor" d="M10.24,0c-.48,0-.88.4-.88.88s.4.88.88.88h.88v1.79C5.49,4.03,1.31,8.99,1.79,14.63c.48,5.63,5.44,9.81,11.09,9.33,5.63-.48,9.81-5.44,9.33-11.09-.18-2.11-1.01-4.1-2.36-5.71l.97-.98c.34-.35.33-.9-.02-1.24-.34-.33-.88-.33-1.22,0l-.98.98c-1.62-1.36-3.62-2.19-5.71-2.36v-1.79h.88c.48,0,.88-.4.88-.88S14.24.01,13.76.01h-3.51,0ZM3.51,13.75c0-4.68,3.8-8.49,8.49-8.49s8.49,3.8,8.49,8.49-3.8,8.49-8.49,8.49S3.51,18.44,3.51,13.75"/>
            </svg>
          </div>
        </template>
        <template #title>
          <div class="has-text-centered">
            Quick Clinical Onboarding
          </div>
        </template>
        <template #content>
          <div class="has-text-centered">
            Start using OVB with patients in minutes
          </div>
        </template>
      </feature-block>
    </div>
  </article>
</template>

<style scoped lang="scss">
$block-width-tablet: 16rem;
  .support-blocks {
    display: flex;
    justify-content: center;
    &-grid {
      display: inline-grid;
      grid-template-columns: 1fr;
      grid-gap: 1rem;
      @include tablet {
        grid-template-columns: 1fr 1fr 1fr;
        grid-gap: 2rem;
        &.is-visible {
          .support-blocks-grid-item {
            animation-name: animateIn;
            animation-duration: 900ms;
            animation-delay: calc(var(--animation-order) * 100ms);
            animation-fill-mode: both;
            animation-timing-function: cubic-bezier(0.34, 1.56, 0.64, 1);
          }
        }
      }
      &-item {
        @include tablet {
          opacity: 0;
          width: $block-width-tablet;
          max-width: $block-width-tablet;
        }
      }
    }
    .image-container {
      max-width: 8rem;
      max-height: 8rem;
      padding: 1rem;
    }
    svg {
      color: $white;
    }
    @keyframes animateIn {
      0% {
        opacity: 0;
        transform: translateY(60px);
      }

      100% {
        opacity: 1;
      }
    }
  }
</style>